import React from 'react';
import { StyleSheet, type StyleProp, type TextStyle, type ViewStyle } from 'react-native';

type Props = {
  href: string;
  onPress: () => void;
  inline?: boolean;
  style?: StyleProp<TextStyle | ViewStyle>;
  children: React.ReactNode;
};

/** A real browser anchor: no React Navigation and no current-page redirect. */
const LegalLink: React.FC<Props> = ({ href, inline = false, style, children }) => React.createElement(
  'a',
  {
    href,
    target: '_blank',
    rel: 'noopener noreferrer',
    onClick: (event: React.MouseEvent<HTMLAnchorElement>) => event.stopPropagation(),
    style: {
      ...(StyleSheet.flatten(style) as React.CSSProperties),
      cursor: 'pointer',
      display: inline ? 'inline' : 'flex',
      textDecoration: 'none',
    },
  },
  children,
);

export default LegalLink;
